import { cx } from '@linaria/core';
import { useRef } from 'react';
import { CircularButton } from '@ui/kit';
import { useHasOverflow, CSSRefTransition } from '@utils/react';
import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../../hook.task-breakpoints.js';
import { GroupDropzone } from './input.dropzone.js';
import { container, buttonFadeDurationMs, scrollButton, label, scroller } from './molecule.dropzones.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function DropzoneContainer(props) {
  const pageContext = usePageContext();
  const context = useTaskContext();
  const isMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  const internalRef = useRef(null);
  const scrollerRef = props.scrollerRef ?? internalRef;
  const [hasOverflow, {
    canScrollLeft,
    canScrollRight
  }] = useHasOverflow(scrollerRef);
  const handleScrollLeft = () => {
    const scroller = scrollerRef.current;
    if (!scroller) {
      return;
    }
    scroller.scrollTo({
      left: Math.max(0, scroller.scrollLeft - 250),
      behavior: "smooth"
    });
  };
  const handleScrollRight = () => {
    const scroller = scrollerRef.current;
    if (!scroller) {
      return;
    }
    scroller.scrollTo({
      left: Math.min(scroller.scrollWidth - scroller.clientWidth, scroller.scrollLeft + 250),
      behavior: "smooth"
    });
  };
  return /*#__PURE__*/jsxs("div", {
    className: container,
    "data-context": context,
    "data-gap": props.dropzones.length > 4 ? "small" : "large",
    "data-page-context": pageContext,
    "data-type": props.facitType,
    children: [/*#__PURE__*/jsx(CSSRefTransition, {
      in: canScrollLeft && hasOverflow && pageContext !== "print",
      classNames: scrollButton,
      timeout: buttonFadeDurationMs,
      mountOnEnter: true,
      unmountOnExit: true,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: cx(scrollButton, "left"),
        children: /*#__PURE__*/jsx(CircularButton, {
          "aria-hidden": true,
          tabIndex: -1,
          inversed: true,
          size: isMobile ? undefined : "large",
          onClick: handleScrollLeft
        })
      })
    }), /*#__PURE__*/jsxs("span", {
      className: label,
      children: [props.dropzones.length, " dropzone", props.dropzones.length !== 1 ? "r" : ""]
    }), /*#__PURE__*/jsx("div", {
      ref: scrollerRef,
      className: scroller,
      children: props.dropzones.map(it => /*#__PURE__*/jsx(GroupDropzone, {
        taskEntryKey: props.taskEntryKey,
        dropzone: it,
        tiles: props.tiles,
        draggable: props.draggable,
        draggedItemKey: props.draggedItemKey,
        facitType: props.facitType
      }, it.id))
    }), /*#__PURE__*/jsx(CSSRefTransition, {
      in: canScrollRight && hasOverflow && pageContext !== "print",
      classNames: scrollButton,
      timeout: buttonFadeDurationMs,
      mountOnEnter: true,
      unmountOnExit: true,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: cx(scrollButton, "right"),
        children: /*#__PURE__*/jsx(CircularButton, {
          "aria-hidden": true,
          tabIndex: -1,
          size: isMobile ? undefined : "large",
          onClick: handleScrollRight
        })
      })
    })]
  });
}

export { DropzoneContainer };
//# sourceMappingURL=molecule.dropzones.js.map
